import React from "react";
import Button from "../../button/button";


function SecondaryButton(props) {
    return <Button styleType="secondary" {...props} />;
}

export default SecondaryButton;

SecondaryButton.propTypes = { ...Button.propTypes };
delete SecondaryButton.propTypes.styleType;

SecondaryButton.defaultProps = { ...Button.defaultProps };
